export default "__VITE_ASSET__dvEguLWe__"